




























































import Vue, { PropType } from 'vue';
import * as InputValidation from '@/mixins/inputValidation';
import { IconData } from '@/icons';
import { Outcome } from '@/models/packet';

import DialogCard from '@/components/DialogCard.vue';
import Goal from '@/components/Goal.vue';
import Icon from '@/components/Icon.vue';
import IconPicker from '@/components/IconPicker.vue';

export default Vue.extend({
  components: {
    DialogCard,
    Goal,
    Icon,
    IconPicker
  },

  props: {
    title: {
      type: String,
      required: true
    },
    iconData: {
      type: Object as PropType<IconData>,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    indicators: {
      type: Array as PropType<Outcome[]>
    }
  },

  data() {
    return {
      nameInput: this.name,
      descriptionInput: this.description,
      objectiveIconData: this.iconData,
      isPickingIcon: false
    };
  },

  computed: {
    isSaveDisabled(): boolean {
      return (
        (this.nameInput === this.name &&
          this.descriptionInput === this.description &&
          this.objectiveIconData.codePoint === this.iconData.codePoint) ||
        !this.nameValidation.valid ||
        !this.descriptionValidation.valid
      );
    },

    nameValidation(): InputValidation.InputLengthValidation {
      return InputValidation.validateInput(this.nameInput, 250);
    },

    descriptionValidation(): InputValidation.InputLengthValidation {
      return InputValidation.validateInput(this.descriptionInput, 1250);
    }
  },

  methods: {
    saveObjective() {
      this.$emit('save', {
        name: this.nameInput,
        description: this.descriptionInput,
        iconData: this.objectiveIconData
      });

      this.objectiveIconData = this.iconData;
      this.descriptionInput = this.description;
      this.nameInput = this.name;
    },

    close() {
      this.$emit('close');
    },

    selectIcon(iconData: IconData) {
      this.objectiveIconData = iconData;
      this.isPickingIcon = false;
    }
  },

  watch: {
    iconData(iconData) {
      this.objectiveIconData = iconData;
    },

    description(description) {
      this.descriptionInput = description;
    },

    name(name) {
      this.nameInput = name;
    }
  }
});
